import {useEffect, useState} from 'react';
import PropTypes from 'prop-types'
import useVariant from 'hooks/useVariant';
import CmsService from 'services/CMS';
import RenderService from 'services/Render';
import {features} from 'config';

let experiment = {};

const getInitialState = () => {
    const data = RenderService.getRenderData();
    if(!(data && data.personalize)) return {};
    const personalize = data.personalize;
    return personalize
}

const WrapperOptimizer = (props) => {
    let initialState = getInitialState();
    const [data, setData] = useState(null);
    const [renderCMS, setRenderCMS] = useState(initialState);
    const [loaded, setLoaded] = useState(null);
    const typeComponent = props.typeComponent;
    const categoryIds = props.categoryIds;
    const variant = useVariant(experiment[typeComponent]);

    const setDataCampaign = (response) => {
        if(response && response.acf){
            setRenderCMS(null)
            let _data = response.acf[typeComponent];
            if(typeComponent === "pdp_shop_together_dynamic"){
                let _campaings = _data.campaigns_category;
                _data.idCategory = categoryIds[0].split('/').filter(Boolean).slice(-1).pop();
                _data.type = "category";
                let idsCategory = _campaings && categoryIds.map(_categoryIds => {
                    return _categoryIds.split('/').reverse().map(item => {
                        let matchCampaigns = _campaings.filter(_item => {
                            let categories_id = _item.category_id.split(',').filter( _id => _id === item) 
                            return !!categories_id.length
                        })
                        if(matchCampaigns.length){
                            return {
                                match : matchCampaigns[0],
                                categoryLevel : _categoryIds
                            }
                        }
                        return false
                    }).filter(Boolean);
                }).filter(item => item.length);
                if(idsCategory && idsCategory.length && idsCategory[0].length){
                    if(_campaings && _campaings.length){
                        _data = idsCategory[0][0].match;
                    }
                }
            }

            if(_data && _data.experiment && _data.experiment.length){
                experiment[typeComponent] = _data.experiment;
            }
            setData(_data)
            setLoaded(true);
        }
    }

    if(renderCMS) setDataCampaign(renderCMS);

    useEffect(() => {
        if(!features.personalize) return false;

        CmsService.getCampaingsCMS().then((response) => {
            setDataCampaign(response)
        })

        return function cleanup(){
            experiment[typeComponent] = null;
        }
    },[]);

    if(!features.personalize) return (typeof props.children === 'function') ? (props.children()) : props.children

    if(!loaded && !renderCMS) return '';

    const getCampaign = (_variant) => {
        if(data && data.campaigns && data.campaigns.length) {
            if(experiment[typeComponent]){
                if(_variant && data.campaigns[_variant]){
                    return (data.campaigns[_variant])
                }else{
                    return null;
                }
            }else{
                return (data.campaigns[0])
            }
        }
    }
    
    const campaign = getCampaign(variant);
    
    if(!campaign) return '';
    campaign.idCategory = data && data.idCategory;
    campaign.type = data && data.type;

    return (typeof props.children === 'function') ? (props.children(campaign)) : props.children;
}

WrapperOptimizer.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string,
        PropTypes.object,
        PropTypes.node,
        PropTypes.func,
        PropTypes.categoryIds
    ])
}

export default WrapperOptimizer;
